import { Button, Dialog as MaterialUIDialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import CONSTANTS from "../constants";

interface DialogProps {
  children?: any;
  titleIcon?: React.ReactNode;
  title: string;
  open: boolean;
  cancelBtnLabel?: string;
  onCancel?: Function;
  okBtnLabel: string;
  onOk: Function;
  disableActions: boolean;
  disableOk?: boolean;
  okBtnClasses?: any;
  customClass?: any;
 
  // declare a variable to indicate close on esc key or click outside of dialog
  closeOnEscOrClick?: boolean;
}

const Dialog: React.FC<DialogProps> = ({ 
  titleIcon, 
  title, 
  open, 
  cancelBtnLabel, 
  onCancel, 
  okBtnLabel, 
  onOk, 
  disableActions, 
  disableOk, 
  children, 
  okBtnClasses, 
  customClass,
  closeOnEscOrClick=true
}) => {

  const cancelCallback = () => { 
    if (onCancel) {
      onCancel();
    }
  }

  const onCancelClick = () => cancelCallback();

  const handleClose = (event: object, reason: string) => {  
    if (closeOnEscOrClick === false && CONSTANTS.DIALOG.CLOSE_REASON.includes(reason)) {
      // When user clicks outside of dialog or esc key is pressed
      // and the reason is one of the esc key or click outside of dialog
      // then do not close the dialog
      return;
    } 
    cancelCallback();
  } 

  return (
    <MaterialUIDialog
      disableBackdropClick
      title={title}
      open={open}
      onClose={handleClose}
      className={customClass}
    >
      <DialogTitle>{titleIcon} {title}</DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        {
          cancelBtnLabel && <Button onClick={onCancelClick} color="primary" disabled={disableActions}>
            {cancelBtnLabel}
          </Button>
        }
        <Button onClick={() => onOk()} className={okBtnClasses} color="primary" disabled={disableOk || disableActions}>
          {okBtnLabel}
        </Button>
      </DialogActions>
    </MaterialUIDialog>
  );
}

export default Dialog;